/**
 * Whose token is this? (spec 15.4) The sync loop runs under the scope `sesi:set` named, and
 * the main thread hands it whatever session Supabase holds. On a shared device the two can
 * part (a sign-in that failed after the password, a newcomer who left Buat PIN): a run must
 * then send nothing, or the newcomer's rights would carry the previous person's outbox and
 * fill their cursor. The access token is a JWT whose `sub` is the user id; it is read here
 * without verification, as a consistency check only (the API verifies every request).
 */

/** The payload of a JWT as an object, read without verification; null when it is not one. */
export function isiToken(token: string): Record<string, unknown> | null {
  const bagian = token.split('.')
  if (bagian.length !== 3 || bagian[1] === undefined) return null
  try {
    const base64 = bagian[1].replace(/-/g, '+').replace(/_/g, '/')
    const isi = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='))) as unknown
    return typeof isi === 'object' && isi !== null ? (isi as Record<string, unknown>) : null
  } catch {
    return null
  }
}

/** The `sub` of a JWT, or null when the token cannot be read as one. */
export function penggunaToken(token: string): string | null {
  const sub = isiToken(token)?.sub
  return typeof sub === 'string' && sub.length > 0 ? sub : null
}

/** True only for a token whose `sub` is `userId`; one that cannot be read fails closed. */
export function tokenMilik(token: string, userId: string): boolean {
  return userId.length > 0 && penggunaToken(token) === userId
}

/**
 * The screens' API client (section 13) asks through this: no token unless it is the
 * session's person's. The sync loop keeps its own provider and its own check (above):
 * during Buat PIN the store holds no person while the first download already runs.
 */
export function tokenUntukLayar(
  ambil: () => Promise<string | null>,
  penggunaSesi: () => string,
): () => Promise<string | null> {
  return async () => {
    const token = await ambil()
    return token !== null && tokenMilik(token, penggunaSesi()) ? token : null
  }
}
